export default {
  section: 'Market Map',
  config: {
    standalone: true,
    title: 'Edit map and chain subcat',
  },
};
